import { JobPageModel } from '../jobModel';
import { JobPageEntry } from '../jobPageEntry';
import { jobsNormalizer } from './jobsNormalizer';

export const paginatedJobsNormalizer = (jobsPageDto: JobPageEntry) => {
  const jobs = jobsNormalizer(jobsPageDto.content ?? []);
  const jobsMap = (jobs ?? []).reduce((acc, job) => {
    return {
      ...acc,
      [job.jobId]: job,
    };
  }, {});
  return {
    totalElements: jobsPageDto.totalElements ?? 0,
    totalPages: jobsPageDto.totalPages ?? 0,
    jobs,
    jobsMap,
    last: jobsPageDto.last ?? false,
    pageable: jobsPageDto.pageable,
  } satisfies JobPageModel;
};
